/**
 * Created by Alex on 09/4/2019.
 * Description:
 *
 * ------ maintenance history ------
 * Marcus add create dynimac Entity Dialog
 * 10/12/2019 Alex Added logic for opening plugin calendar page
 * 08/10/2022 Alex Moved the logic of saving entity type to store to function _initGlobalConstantData to solve TAM-38463
 */

import { Component, OnInit, AfterViewInit, ComponentRef, ViewChild, ViewContainerRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { NoteDialogOpenOptions, NoteDialogType } from '../../components/note-dialog/note-dialog.model';
import { NoteDialogService } from '../../components/note-dialog/note-dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityDialogComponent } from '../../components/entity-dialog/entity-dialog.component';
import { EntityDialogOpenOptions, EntityDialogType } from '../../components/entity-dialog/entity-dialog.model';
import { EntityConfigurationConstants, ContactConfigurationConstants } from '@tamalelibs/models/smart-reducer.model';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../redux';
import { EntityDialogService } from '../../components/entity-dialog/entity-dialog.service';
import { OpenDynamicComponentService } from '../home/home-open-dynamic-component';
import { RelationshipTypeActionTypes } from '../../redux/actions/relationship-type.actions';
import { EntityTypeActionTypes } from '../../redux/actions/entity-type.actions';
import { TeamsActionTypes } from '../../redux/actions/teams.actions';
import { CalendarDialogType, CalendarDialogOpenOptions } from '../../components/calendar-dialog/calendar-dialog.model';
import { CalendarDialogService } from '../../components/calendar-dialog/calendar-dialog.service';
import { UsersActionTypes } from '../../redux/actions/users.actions';
import { DialogAction } from '../../widgets/tam-dialog/tam-dialog.model';
import { DynamicComponentService } from '../../services/dynamic-component.service';
import { ContactTemplateOpenOptions, ContactTemplateType } from '../../components/contact-dialog-new/contact-dialog.model';
import { ContactTemplateService } from '../../components/contact-dialog-new/contact-template.service';
import { HomeViewModel } from '../home/home-view.model';
import { filter, take } from 'rxjs/operators';
import { SystemActionTypes } from '@tamalelibs/redux/actions/system.actions';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
// tslint:disable-next-line: import-blacklist
import { Subscription } from 'rxjs';
import { ContactDialogComponent } from '../../components/contact-dialog/contact-dialog.component';
import { ContactService } from '@tamalelibs/services/contact.service';
import { SAVE_CONTACT_TEMPLATE } from '@tamalelibs/redux/contact.actions';
import { businessConstants, SSOCookiesKey } from '../../constants/business.constants';
import { SystemConfig } from '../../models/global-setting';
import * as stomp from 'stompjs';
import { SystemUser } from '@tamalelibs/models/user.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { MessageService } from '../../services/message.service';
import { BriefConfig } from '../../widgets/widgets.model';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { ToastService } from '../../widgets/toast/toast.service';
import { OfficeAddIn } from '@tamalelibs/models/office-addin.model';
import { AuthService } from '@tamalelibs/services/auth.service';
import { AppConfig } from '@tamalelibs/models/app-config.model';
import { AddInUtilities } from '../../services/utilities/addin-utilities';
import { HomePluginService } from './home-plugin.service';
import { AddInDepositType, AddInDialogType } from '../../models/addin.model';
import { ContactDialogOpenOptions, ContactDialogType } from '../../components/contact-dialog/contact-dialog.model';
import { WindowRef } from '../../services/window-ref';
import { FormulajsExtensionService } from '../../services/formulajs-extension.service';
import { AuthHelperService } from '../../services/auth-helper.service';
import { StorageService } from '../../services/storage.service';
declare const Office: any;

@Component({
    selector: 'tam-home-plugin',
    templateUrl: './home-plugin.component.html',
    styleUrls: ['./home-plugin.component.scss'],
    providers: [HomeViewModel],
    standalone: false
})
export class HomePluginComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('flyContainer', { static: false, read: ViewContainerRef }) container: ViewContainerRef;

    instanceId = '';

    client: any; // websocket client
    componentRef: ComponentRef<any>;
    currentUser: SystemUser;
    filePreviewConfig: BriefConfig;
    officeAddIn: OfficeAddIn;

    private _mqConnected = false;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _authService: AuthService,
        private _authHelper: AuthHelperService,
        private _homePluginService: HomePluginService,
        private _noteDialogService: NoteDialogService,
        private _routeInfo: ActivatedRoute,
        private _eventDialogService: CalendarDialogService,
        private _store: Store<AppState>,
        private _router: Router,
        private _entityDialogService: EntityDialogService,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _dynamicComponentService: DynamicComponentService,
        private _contactTemplateService: ContactTemplateService,
        private _homeViewModel: HomeViewModel,
        private _contactService: ContactService,
        private _storeQuerier: StoreQuerierService,
        private _messageService: MessageService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _toast: ToastService,
        private _winRef: WindowRef,
        private _formulaExt: FormulajsExtensionService,
        private _storageService: StorageService,
    ) { }

    ngOnInit() {
        this._checkTokenValid();
        this.currentUser = this._storeQuerier.getCurrentUser();
        this.filePreviewConfig = new BriefConfig();
        this._destroySubscriptions.push(
            this._openDynamicComponentService.openDialog$.subscribe((event) => {
                this._initConstantDataForDialog();
                this._createComponent(event);
            }),
            this._openDynamicComponentService.openContactDialog$.subscribe((event) => {
                this._contactService.getContactTemplate(businessConstants.Contacts.Contact_Template_Id)
                    .subscribe(res => {
                        this._initConstantDataForDialog();
                        this._getTemplateConfig(res);
                        this._createContactComponent(event);
                    });
            }),
            this._openDynamicComponentService.feedbackSubject$.subscribe(res => {
                let index;
                this._homeViewModel.getFlyIndex().pipe(take(1)).subscribe(_res => index = _res);
                if (res === DialogAction.CloseDialog && index && index > 0) {
                    this._homeViewModel.decrement();
                    if (AddInUtilities.isOfficeJSLoaded()) {
                        this.container.remove(index - 1);
                        this._closeDialogBox(index);
                    } else {
                        this.container.remove(index);
                    }
                }
            }),

            // TAM-32157: listen to the file preview close action
            this.filePreviewConfig.actionSubject$.subscribe(() => {
                this._toast.notify({
                    message: 'File preview timeout.',
                    style: NotificationStyles.Error
                });
                // workaround to popup a notification when there is an error in file preview
                this._changeDetectorRef.detectChanges();
                setTimeout(() => {
                    this._changeDetectorRef.detectChanges();
                }, 3000);
            }),
        );

        this._initFormula();
        this._changeDetectorRef.detectChanges();
    }

    get getAddInMode(): boolean {
        return AddInUtilities.isOfficeJSLoaded() ? true : false;
    }

    ngAfterViewInit() {
        const myself = this;
        if (AddInUtilities.isOfficeEnvironment() && Office.context.mailbox) {
            Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, () => {
                myself._initDialogView(true);
            });
        }

        this._changeDetectorRef.detectChanges();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    /**
    * for office add-in, we need to remove the token and userId in local storage
    */
    private _checkTokenValid() {
        const _self = this;
        if (AddInUtilities.isOfficeEnvironment() && AppConfig.token) {
            // temporary log info, added for PM
            console.log('tamale add-in:' + navigator.userAgent);
            console.log('tamale add-in:' + AddInUtilities.isOfficeSupportedVersion('1.3'));
            this._authService.isTokenValid(AppConfig.token).pipe(
                take(1),
            ).subscribe(res => {
                if (res.toString() === 'false') {
                    AppConfig.token = '';
                    localStorage.removeItem('token');
                    localStorage.removeItem('userId');
                    _self._storageService.removeItem(SSOCookiesKey);
                    window.location.reload();
                } else {
                    this._initGlobalConstantData();
                }
            });
        } else if (this._router.url.includes('/popoutentry/') || this._router.url.includes('/pluginentry/')|| this._router.url.includes('/pluginevent/')) {
            const token = this._authHelper.getToken();
            if (token) {
                this._initGlobalConstantData();
            }
        }
    }

    /**
    * create a dynimac entity-dialog component
    */
    private _createComponent(entityDialogOpenOptions: EntityDialogOpenOptions) {
        this.componentRef = this._dynamicComponentService.loadComponent<EntityDialogComponent>
            (this.container, EntityDialogComponent, false);
        this.componentRef.instance.id = entityDialogOpenOptions.instanceId;
        this._store.dispatch({
            type: EntityConfigurationConstants.AddActionTypeName,
            prefix: entityDialogOpenOptions.instanceId
        });
        setTimeout(() => {
            this._entityDialogService.dialogOpen$.next(entityDialogOpenOptions);
        });
    }

    private _createContactComponent(contactDialogOpenOptions: ContactTemplateOpenOptions) {
        this.componentRef = this._dynamicComponentService.loadComponent<ContactDialogComponent>
            (this.container, ContactDialogComponent, false);
        this.componentRef.instance.id = contactDialogOpenOptions.instanceId;
        this._store.dispatch({
            type: ContactConfigurationConstants.AddActionTypeName,
            prefix: contactDialogOpenOptions.instanceId
        });
        setTimeout(() => {
            this._contactTemplateService.dialogOpen$.next(contactDialogOpenOptions);
        });
    }

    private _initDialogView(isPinModeOfAddIn?: boolean) {
        if (this._isOpenEntryEditPage()) {
            if (this._router.url.indexOf('/popoutentry/') > -1) {
                this._initNewNotePage(true);
            } else {
                this._initNewNotePage(false);
            }
        } else if (this._isOpenPluginAddInPage()) {
            // Open new note page for office add-in
            this._homePluginService.OpenNewNotePageForOfficeAddIn(isPinModeOfAddIn);
        } else if (this._router.url.indexOf(AddInDialogType.ENTITYDIALOG.toLowerCase()) > -1) {
            this._initNewEntityDialogPage();
        } else if (this._router.url.indexOf(AddInDialogType.CONTACTDIALOG.toLowerCase()) > -1) {
            this._initNewContactDialogPage();
        } else {
            // calendar from plugin
            this._initPluginEditEventPage();
        }
        this._changeDetectorRef.detectChanges();
    }

    private _initFormula() {
        // init data for formula
        this._winRef.nativeWindow.Formula = Object.assign({}, this._formulaExt.formulajs); // must use copy
        this._winRef.nativeWindow.Formula.ISBLANK = this._formulaExt.ISBLANK;
        this._winRef.nativeWindow.Formula.DATEDIFF = this._formulaExt.DATEDIFF;
        this._winRef.nativeWindow.Formula.DATEADD = this._formulaExt.DATEADD;
        this._winRef.nativeWindow.Formula.ISERR = this._formulaExt.ISERR;
        this._winRef.nativeWindow.Formula.ISERROR = this._formulaExt.ISERROR;
        this._winRef.nativeWindow.Formula.ISLEAPYEAR = this._formulaExt.ISLEAPYEAR;
        this._winRef.nativeWindow.Formula.DAYSBETWEEN = this._formulaExt.DAYSBETWEEN;
    }

    /**
     * init for plugin and popup entry
     * @param isPopupEntryMode
     */
    private _initNewNotePage(isPopupEntryMode) {
        const _noteOption = new NoteDialogOpenOptions();

        if (this._routeInfo.snapshot.params['id'].indexOf('entry-type') > -1) {
            _noteOption.openType = NoteDialogType.CreateNote;
            const entryTypeId = this._routeInfo.snapshot.params['id'].split(':')[1];
            _noteOption.entryTypeId = entryTypeId;
        } else {
            _noteOption.entryId = this._routeInfo.snapshot.params['id'];
            _noteOption.openType = NoteDialogType.EditDraft;
        }
        if (isPopupEntryMode) {
            _noteOption.isPlugInEditNoteMode = !isPopupEntryMode;
            _noteOption.isPopupEntryMode = isPopupEntryMode;
        } else {
            _noteOption.isPlugInEditNoteMode = true;
        }
        _noteOption.entityFieldEditable = true;
        _noteOption.entityFieldEditable = true;
        this._noteDialogService.dialogOpen$.next(_noteOption);
    }

    private _initPluginEditEventPage() {
        const _noteOption = new CalendarDialogOpenOptions();
        _noteOption.entryId = this._routeInfo.snapshot.params['id'];
        _noteOption.openType = CalendarDialogType.EditEvent;
        _noteOption.isPluginInEditEventMode = true;
        _noteOption.minimizable = true;
        this._eventDialogService.dialogOpen$.next(_noteOption);
    }

    private _initGlobalConstantData() {
        this._store.dispatch({
            type: EntityTypeActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: UsersActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: UsersActionTypes.LOAD_USER_SETTING
        });
        this._store.dispatch({
            type: SystemActionTypes.GET_UNCATEGORUZEEID
        });

        this._destroySubscriptions.push(
            this._store.pipe(select(lastCustomActionSelector),
            ).subscribe(action => this._actionMessageHandler(action)),
            // to control appcue
            this._store.pipe(
                select('systemConfig'),
                filter(item => item),
                take(1),
            ).subscribe((systemConfig: SystemConfig) => {
                try {
                    this._initWebSocket(systemConfig);
                } catch (err) {
                    console.error(err);
                }
            }),
        );
    }

    private _initConstantDataForDialog() {
        this._store.dispatch({
            type: TeamsActionTypes.INITIALIZE
        });

        this._store.dispatch({
            type: RelationshipTypeActionTypes.INITIALIZE
        });
    }

    private _initWebSocket(systemConfig: SystemConfig) {
        let wshost = window.location.host;
        let wsurl;
        wshost = wshost + ':' + systemConfig.mq.webSocketPort;
        wsurl = systemConfig.mq.webSocketProtocol + '://' + wshost + '/stomp';

        const login = 'consumer';
        const passcode = 'Tamale2018';
        const destination = '/topic/tamaleweb';
        if (wsurl) {
            this.client = stomp.client(wsurl);
            // this allows to display debug logs directly on the web page
            this.client.debug = (str) => {
                // console.log(str);
            };
            // the client is notified when it is connected to the server.
            const userId = this.currentUser ? this.currentUser.id : '';
            const headers = { ack: 'client', selector: `PublicEntity = TRUE OR IDs LIKE '%${userId}%'` };
            const onconnect = (frame) => {
                console.log('on connect');
                console.log(frame);
                this._destroySubscriptions.push(
                    this.client.subscribe(destination, (message) => {
                        this._onMessage(message);
                    }, headers),
                );
                this._mqConnected = true;
            };
            const onconnectError = (err) => {
                console.warn('can not connect, please check MQ configuration on admin');
                this._mqConnected = false;
            };
            this.client.connect(login, passcode, onconnect, onconnectError);
        }
    }

    private _isOpenEntryEditPage() {
        return this._router.url.indexOf('/pluginentry/') > -1 || this._router.url.indexOf('/popoutentry/') > -1;
    }

    private _isOpenPluginAddInPage() {
        return this._router && this._router.url && (this._router.url.indexOf(AddInDepositType.ADDINALL.toLowerCase()) > -1 || this._router.url.indexOf(AddInDepositType.ADDINONLYEMAIL.toLowerCase()) > -1 || this._router.url.indexOf(AddInDepositType.ADDINONLYFILE.toLowerCase()) > -1);
    }

    private _initNewEntityDialogPage() {
        let _entityDialogOpenOptions = new EntityDialogOpenOptions();
        if (localStorage.getItem(businessConstants.officeAddIn.entityFly)) {
            this._homeViewModel.increment();
            _entityDialogOpenOptions = JSON.parse(localStorage.getItem(businessConstants.officeAddIn.entityFly));
            localStorage.removeItem(businessConstants.officeAddIn.entityFly);
            // stop sending message from parent window for entity on the fly
            Office.context.ui.messageParent(businessConstants.officeAddIn.gotUser);
        }
        this._openDynamicComponentService.openDialog$.next(_entityDialogOpenOptions);
    }

    private _initNewContactDialogPage() {
        let _contactDialogOpenOptions = new ContactDialogOpenOptions();
        if (localStorage.getItem(businessConstants.officeAddIn.contactFly)) {
            this._homeViewModel.increment();
            _contactDialogOpenOptions = JSON.parse(localStorage.getItem(businessConstants.officeAddIn.contactFly));
            localStorage.removeItem(businessConstants.officeAddIn.contactFly);
            // stop sending message from parent window for contact on the fly
            Office.context.ui.messageParent(businessConstants.officeAddIn.gotUser);
        }
        this._openDynamicComponentService.openContactDialog$.next(_contactDialogOpenOptions);
    }

    private _actionMessageHandler(action) {
        if (action.type === SystemActionTypes.GET_UNCATEGORUZEEID_SUCCESS || action.type === SystemActionTypes.GET_UNCATEGORUZEEID_FAILED) {
            this._initDialogView();
        }
    }

    private _getTemplateConfig(res) {
        const templateSettings = this._contactService.getTemplateConfig(res);
        this._store.dispatch({
            type: SAVE_CONTACT_TEMPLATE,
            payload: templateSettings
        });
    }

    private _onMessage(message) {
        const body: string = message.body;
        if (body && body.indexOf('{') === 0 && body.lastIndexOf('}') === body.length - 1) {
            const action: { type: string, payload: any } = JSON.parse(body);
            this._messageService.parseMessage(action, []);
        }
    }

    /**
     * close the dialog box only when the button of 'cancel' is clicked on the first dialog for add-in.
     */
    private _closeDialogBox(index: number) {
        if (AddInUtilities.isOfficeEnvironment() && index === 1) {
            Office.context.ui.messageParent(businessConstants.officeAddIn.closeEntityFly);
        }
    }
}
